import React, { useState } from "react";
import { PageContainer, ButtonListContainer } from "./Garage.styled";
import { ButtonsList } from "@ann/web-components";
import { Paginator, Content, FiltersContainer } from "./components";
import { useGaragePage } from "../../hooks/useGaragePage";

const Garage = () => {
  const [selectedTab, setSelectedTab] = useState("all");

  const {
    contactId,
    loading,
    filtersLoading,
    error,
    isEmpty,
    vehicles,
    vehiclesMeta,
    filters,
    filterHandlers,
    filterUI,
    handlePageChange,
    handleItemsPerPageChange,
    handleRefresh,
  } = useGaragePage();

  const handleTabChange = (tabId) => {
    setSelectedTab(tabId);
  };

  return (
    <PageContainer>
      <ButtonListContainer>
        <ButtonsList
          items={[
            {
              label: "All",
              onClick: () => handleTabChange("all"),
              selected: selectedTab === "all" || selectedTab === "",
            },
            {
              label: "Currently Owns",
              onClick: () => handleTabChange("currentlyOwns"),
              selected: selectedTab === "currentlyOwns",
            },
            {
              label: "Previously Owned",
              onClick: () => handleTabChange("previouslyOwned"),
              selected: selectedTab === "previouslyOwned",
            },
            {
              label: "Interested in",
              onClick: () => handleTabChange("interestedIn"),
              selected: selectedTab === "interestedIn",
            },
          ]}
          size="medium"
        />
      </ButtonListContainer>
      <FiltersContainer
        loading={filtersLoading}
        filters={filters}
        filterHandlers={filterHandlers}
        filterUI={filterUI}
      />
      <Content loading={loading} error={error} isEmpty={isEmpty} vehicles={vehicles} contactId={contactId} onRefresh={handleRefresh} />
      <Paginator
        meta={vehiclesMeta}
        onPageChange={handlePageChange}
        onItemsPerPageChange={handleItemsPerPageChange}
      />
    </PageContainer>
  );
};

export default Garage;
